/** AT: Automatically translate the contents, will wind up being either a fragment
 * with a t() call, or a fragment with a <Trans> component.
 */

import { type FunctionComponent, type PropsWithChildren } from "react";

export const AT: FunctionComponent<PropsWithChildren> = ({ children }) => <>{children}</>;
